import apiClient from './api';
import { Expense, NewExpense, PaymentReceived, NewPaymentReceived, EmployeePettyCashSummary, AdvancePettyCash, NewAdvancePettyCash } from '../types/accounting';

interface GetExpensesParams {
  search?: string;
  project?: string;
  category?: string;
  submitted_by?: string;
  start_date?: string;
  end_date?: string;
}

const getExpenses = async (params?: GetExpensesParams): Promise<Expense[]> => {
  const response = await apiClient.get<Expense[]>('/accounting/expenses/', { params });
  return response.data;
};

const createExpense = async (expenseData: NewExpense): Promise<Expense> => {
  const response = await apiClient.post<Expense>('/accounting/expenses/', expenseData);
  return response.data;
};

// NEW: Function to update an existing expense
const updateExpense = async (id: number, data: Partial<Expense>): Promise<Expense> => {
  // We use PATCH to only update the fields sent in the 'data' object
  const response = await apiClient.patch<Expense>(`/accounting/expenses/${id}/`, data);
  return response.data;
};

interface GetPaymentsParams {
  search?: string;
  project?: string;
  start_date?: string;
  end_date?: string;
  received_by?: string;
}

const getPayments = async (params?: GetPaymentsParams): Promise<PaymentReceived[]> => {
  const response = await apiClient.get<PaymentReceived[]>('/accounting/payments/', { params });
  return response.data;
};

const createPayment = async (paymentData: NewPaymentReceived): Promise<PaymentReceived> => {
  const response = await apiClient.post<PaymentReceived>('/accounting/payments/', paymentData);
  return response.data;
};

const getEmployeePettyCashSummary = async (): Promise<EmployeePettyCashSummary[]> => {
  const response = await apiClient.get<EmployeePettyCashSummary[]>('/accounting/employee-petty-cash-summary/');
  return response.data;
};

const getAdvancePettyCashForUser = async (userId: number): Promise<AdvancePettyCash[]> => {
  const response = await apiClient.get<AdvancePettyCash[]>('/accounting/advance-petty-cash/', { params: { paid_to: userId } });
  return response.data;
};

const createAdvancePettyCash = async (data: NewAdvancePettyCash): Promise<AdvancePettyCash> => {
  const response = await apiClient.post<AdvancePettyCash>('/accounting/advance-petty-cash/', data);
  return response.data;
};


export const accountingService = {
  getExpenses,
  createExpense,
  updateExpense,
  getPayments,
  createPayment,
  getEmployeePettyCashSummary,
  getAdvancePettyCashForUser,
  createAdvancePettyCash,
};